import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { devicesActions, groupsActions, positionsActions, sessionActions } from './store';
import { useEffectAsync } from './reactHelper';
import { getItem, getItemWithoutHeaders } from './fetch';

import { selectAuthenticatedUser, selectSession } from './createSelectorUtils';

const displayNotifications = (events) => {
  if ('Notification' in window) {
    if (Notification.permission === 'granted') {
      // eslint-disable-next-line no-restricted-syntax
      for (const event of events) {
        const notification = new Notification(`Event: ${event.type}`);
        setTimeout(notification.close.bind(notification), 4 * 1000);
      }
    } else if (Notification.permission !== 'denied') {
      Notification.requestPermission((permission) => {
        if (permission === 'granted') {
          displayNotifications(events);
        }
      });
    }
  }
};

function SocketController(props) {
  const dispatch = useDispatch();

  const authenticated = useSelector(selectAuthenticatedUser);
  const session = useSelector(selectSession);

  const navigate = useNavigate();

  const connectSocket = () => {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const socket = new WebSocket(`${protocol}//${window.location.host}/api/socket`);
    socket.onclose = () => {
      setTimeout(() => connectSocket(), 60 * 1000);
    };

    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.devices) {
        props.dispatch(devicesActions.update(data.devices));
      }
      if (data.positions) {
        props.dispatch(positionsActions.update(data.positions));
      }
      if (data.events) {
        displayNotifications(data.events);
      }
    };
  };

  useEffectAsync(async () => {
    if (
      window.location.pathname !== '/reset/password' &&
      window.location.pathname !== '/vol/share' &&
      window.location.pathname !== '/first/connection/reset'
    ) {
      if (!authenticated) {
        const responseSession = await getItemWithoutHeaders('session');
        if (responseSession.ok) {
          const result = await responseSession.json();
          dispatch(sessionActions.update(result));
          dispatch(sessionActions.authenticated(await true));

          const groupId =
            JSON.parse(window.localStorage.getItem('groupId')) ||
            JSON.parse(window.localStorage.getItem('groupId')) === 0
              ? JSON.parse(window.localStorage.getItem('groupId'))
              : (result.permission && result.permission[0] && result.permission[0].groupid) || 0;

          const permission = result.permission.find((item) => item.groupid === groupId) || {};

          if (!result.administrator) {
            dispatch(groupsActions.select(groupId));
          } else {
            dispatch(groupsActions.select(0));
          }

          if (
            window.location.pathname === '/login' ||
            window.location.pathname === '/register' ||
            window.location.pathname === '/forgot/password'
          ) {
            if (permission && permission.status < 3) {
              navigate('/live/map');
            } else {
              navigate('/dashboard');
            }
          }
        } else {
          // console.log(`${responseSession.status} - ${responseSession.statusText}`);
          navigate('/login');
        }
      } else {
        const responseDevices = await getItem(
          session.administrator ? 'devices?all=true' : 'devices'
        );
        if (responseDevices.ok) {
          const resultDevices = await responseDevices.json();
          resultDevices.sort((a, b) => a.name.localeCompare(b.name));
          dispatch(devicesActions.update(await resultDevices));
        }

        connectSocket();
      }
    }
  }, [authenticated, session]);

  return null;
}
SocketController.propTypes = {
  dispatch: PropTypes.func
};

export default connect()(SocketController);
